module.exports = __webpack_public_path__ + "static/media/horoscop_icon.08ea0939.svg";